// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__23OPZ","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1bL7w","obliqueLine":"membershipbadge_obliqueLine__1ZGHv"};